import { PluginListenerHandle } from '@capacitor/core';

export enum PinchGestureState {
    possible = 'possible',
    began = 'began',
    changed = 'changed',
    ended = 'ended',
    cancelled = 'cancelled',
    failed = 'failed',
    unknown = 'unknown',
}

export type PinchGesturePosition = {
    x: number;
    y: number;
};

export type PinchGestureData = {
    state: PinchGestureState;
    scale: number;
    velocity: number;
    centre: PinchGesturePosition;
};

export interface TrackpadPinchPluginInterface {
    // Listener functions
    addListener(
        eventName: 'trackpadPinch',
        listenerFunc: (data: PinchGestureData) => void,
    ): Promise<PluginListenerHandle>;

    removeAllListeners(): void;
}
